import React, { useState } from 'react';

import {
	IonContent,
	IonLabel,
	IonPage,
	IonSegment,
	IonSegmentButton,
} from '@ionic/react';
import UserAvatar from '../components/Global/SearchHeader/UserAvatar';
import { SegmentContainer } from '../components/PlacePage/Media/mediaStyles';
import { BookmarksHeader } from '../components/Catalogue/Bookmarks/bookmarkStyles';
import BookmarksHandler from '../components/Catalogue/Bookmarks/BookmarksHandler';
import PageHeader from '../components/Global/PageHeader/PageHeader';

type BookmarksProps = {};

const Bookmarks: React.FC<BookmarksProps> = ({}) => {
	// const [list, setList] = useState<string[]>([]);
	const [listKey, setListKey] = useState('trails');

	return (
		<IonPage>
			<IonContent fullscreen>
				<main>
					{/* <UserAvatar /> */}
					<PageHeader title="Your bookmarks" />
					<SegmentContainer>
						<IonSegment
							value={listKey}
							onIonChange={(e) => {
								if (e.detail.value === undefined) return;
								setListKey(e.detail.value);
							}}>
							<IonSegmentButton value="trails">
								<IonLabel>Trails</IonLabel>
							</IonSegmentButton>
							<IonSegmentButton value="places">
								<IonLabel>Places</IonLabel>
							</IonSegmentButton>
							<IonSegmentButton value="stories">
								<IonLabel>Stories</IonLabel>
							</IonSegmentButton>
						</IonSegment>
					</SegmentContainer>
					{/* TODO: Pass appropriate data here (Need to be thoughful)*/}
					<BookmarksHandler listKey={listKey} />
				</main>
			</IonContent>
		</IonPage>
	);
};

export default Bookmarks;
